module.exports = __webpack_public_path__ + "static/tom-60a94031fec1c3ecd89f5607267af79b.jpg";